import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  .AboutUsContent {
    padding: 30px 15px;
    font-size: 18px;
    h2 {
      font-family: ${typography.Serif};
      font-size: 32px;
    }
    @media (min-width: 992px) {
      padding: 90px 0;
    }
  }
  .AboutUsContent_section {
    background-color: #f4f4f4;
    margin: 50px 0;
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      flex-direction: row;
      &:nth-child(2n) {
        flex-direction: row-reverse;
      }
    }
  }
  .AboutUsContent_section-left {
    margin: 0 30px;
  }
  .AboutUsContent_section-right {
    img {
      max-width: 100%;
    }
    @media (min-width: 992px) {
      img {
        max-width: 600px;
      }
    }
  }
  .AboutUsContent_headline {
    font-family: ${typography.Serif};
    font-size: 30px;
    position: relative;
    margin-bottom: 30px;

    &:after {
      content: '';
      background: ${colors.color2};
      width: 100px;
      height: 3px;
      position: absolute;
      display: block;
      bottom: -15px;
    }
  }
`;

function AboutUsContent({ page }) {
  return (
    <div className={styles}>
      <div className="AboutUsContent container">
        <h2>Our Story</h2>
        {get(page, 'lead_copy')}
        {
          get(page, 'page_section').map(section => {
            return (
              <div key={section.headline} className="AboutUsContent_section">
                <div className="AboutUsContent_section-left">
                  <h3 className="AboutUsContent_headline">{section.headline}</h3>
                  <div dangerouslySetInnerHTML={SanitizeHtml(section.text)} />
                </div>
                <div className="AboutUsContent_section-right">
                  <img src={section.photo.contentUrl} alt={section.photo.alt} />
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

AboutUsContent.propTypes = {
  page: PropTypes.object.isRequired,
};

export default AboutUsContent;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/AboutUsContent.js